
import ErrorPage from './views/404'
export default () => {
  return [
    {
      path: '/',
      redirect: { name: 'root' }
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        icon: 'lock',
        auth: false
      },
      component: () => System.import('./views/login')
    },
    {
      path: '*',
      meta: {
        icon: 'lock',
        auth: false
      },
      component: ErrorPage
    }
  ]
}



// WEBPACK FOOTER //
// ./src/modules/user/create-routes.js